export default class EditEvidenceCtrl {
  constructor ($scope, $mdDialog, PortfolioSrv, PortfolioModalSrv, GlobalConfig, FileUploader, SERVICE_URL_CONSTANT) {
  // constants
    const regexp = {
      image : /^(jpg|png|jpeg|bmp|gif)$/,
      audio : /^(mp3|mpeg-4|wma)$/,
      video : /^(mp4|mkv|avi|wmv)$/,
      document : /^(doc|docx|xls|xlsx|pdf)$/
    }
    var editEvidenceVm = this
    editEvidenceVm.sharedVariable  = PortfolioModalSrv.getVariable()
  // variables
    editEvidenceVm.evidence            = editEvidenceVm.sharedVariable.evidence
    editEvidenceVm.comment             = ''
    editEvidenceVm.fileName            = ''
    editEvidenceVm.attachFile          = ''  
    editEvidenceVm.loading             = false
    editEvidenceVm.errorMsg            = false
    editEvidenceVm.errorMsgFileType    = ''
    editEvidenceVm.disableButtonUpload = false
    editEvidenceVm.showUploader        = true
    editEvidenceVm.acceptFileType      = ''
    editEvidenceVm.fileTypes           = []
    editEvidenceVm.evidencesTypes      = []     
    editEvidenceVm.globalFileTypes     = GlobalConfig.portfolioConfig.fileTypes                     
    editEvidenceVm.disableButtonAdd    = false

  // methods
    editEvidenceVm.close             = close
    editEvidenceVm.updateEvidence    = updateEvidence
    editEvidenceVm.showErrorMessages = showErrorMessages
    editEvidenceVm.hasError          = hasError
    editEvidenceVm.validateForm      = validateForm    
    editEvidenceVm.remove            = remove
    editEvidenceVm.setFilterUploader = setFilterUploader
    
  //initial functions
    function activate(){
      setValues()
      setFilterUploader()
      PortfolioSrv.getBasicsRegistry.get().$promise.then((dataReturn) => {
        if (dataReturn.status) {
          editEvidenceVm.fileTypes      = dataReturn.fileTypes
          editEvidenceVm.evidencesTypes = dataReturn.evidencesTypes
        }
      })
    }

    function close () {
      PortfolioModalSrv.setVariable({status : false})
      return $mdDialog.hide()
    }  

    function updateEvidence () {
      editEvidenceVm.disableButtonAdd = true
      let header = {
        blogId      : editEvidenceVm.blogId,
        title       : editEvidenceVm.title,
        description : editEvidenceVm.description,
        idSubitem   : editEvidenceVm.evidenceType,
        fileType    : editEvidenceVm.fileTypeId,
        fileName    : editEvidenceVm.fileName //este valor debe obtener cuando el archivo sea adjuntado 
      }     
      PortfolioSrv.updateEvidence.update(header).$promise.then((dataReturn) => {
        if (dataReturn.status) {
          PortfolioModalSrv.setVariable({status : dataReturn.status})
          return $mdDialog.hide()         
        } else {
          editEvidenceVm.disableButtonAdd = false
        }
      })
      
    }

    function setValues(){
      editEvidenceVm.blogId           = editEvidenceVm.evidence.blogId
      editEvidenceVm.description      = editEvidenceVm.evidence.blogDescription
      editEvidenceVm.title            = editEvidenceVm.evidence.blogTitle
      editEvidenceVm.evidenceType     = editEvidenceVm.evidence.blogSubTypeId
      editEvidenceVm.fileTypeId       = editEvidenceVm.evidence.blogFileType
      editEvidenceVm.attachFile       = editEvidenceVm.evidence.fileName
      editEvidenceVm.fileName         = editEvidenceVm.evidence.blogUrlFile
      editEvidenceVm.STATIC_IMAGE_URL = true 
      

    }

  //upload methods
    function setFilterUploader(){
      let name = ''
      let extensions = '' 
      let pattern 
      if(isImageType(editEvidenceVm.fileTypeId)){
        name       = 'imageFilter'
        extensions = '|jpg|png|jpeg|bmp|gif|'
        editEvidenceVm.acceptFileType = 'image/*'
        pattern = regexp.image
      }
      if(isAudioType(editEvidenceVm.fileTypeId)){
        name       = 'audioFilter'
        extensions = '|mp3|mpeg-4|wma|'
        editEvidenceVm.acceptFileType = 'audio/*'
        pattern = regexp.audio
      }
      if(isVideoType(editEvidenceVm.fileTypeId)){
        name       = 'videoFilter'
        extensions =  '|mp4|mkv|avi|wmv|'
        editEvidenceVm.acceptFileType = 'video/*'
        pattern = regexp.video
      }
      if(isDocumentType(editEvidenceVm.fileTypeId)){
        name       = 'documentFilter'
        extensions =  '|doc|docx|xls|xlsx|pdf|'
        editEvidenceVm.acceptFileType = 'application/pdf,application/vnd.ms-excel,application/msword'
        pattern = regexp.document
      }

      uploader.filters.pop()
      uploader.filters.push({
          name: name,
          fn: function(item, options) {
                var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|'
                return extensions.indexOf(type) !== -1
              }
      })    
      editEvidenceVm.showUploader = true
      $('#inputFileUpload').val(null)
      $('#inputFileUpload2').val(null)
      editEvidenceVm.disableButtonUpload = true

      if (editEvidenceVm.attachFile != ''){
        checkExtensionFile(editEvidenceVm.fileTypeId,editEvidenceVm.attachFile, pattern)
      }

    }

    function checkExtensionFile(fileType, filename, pattern){
      let ext = filename.substring(filename.lastIndexOf(".") + 1)
      if(pattern.test(ext)){
        editEvidenceVm.errorMsgFileType = ''
      } else {
        editEvidenceVm.errorMsgFileType = 'El archivo adjunto no es el de tipo seleccionado'
      }
    }

    var uploader = $scope.uploader = new FileUploader({
      url: SERVICE_URL_CONSTANT.rosario+'/file/uploadFilePortfolio?userId='+editEvidenceVm.evidence.blogUser 
    })

    // a sync filter
    uploader.filters.push({
      name: 'syncFilter',
      fn: function(item, options) {
      //console.log('syncFilter');
      return this.queue.length < 10;
      }
    })

    // an async filter
    uploader.filters.push({
      name: 'asyncFilter',
      fn: function(item, options, deferred) {
        //console.log('asyncFilter')
        setTimeout(deferred.resolve, 1e3)
      }
    })

    uploader.filters.push({
      name: 'emptyFilter',
      fn: function(item, options) {
        return true
      }
    })

    uploader.onWhenAddingFileFailed = function(item, filter, options) {
      //console.info('onWhenAddingFileFailed', item, filter, options)
      editEvidenceVm.errorMsgFileType    = 'El archivo no es el de tipo seleccionado'
      editEvidenceVm.disableButtonUpload = true
      $('#inputFileUpload').val(null)
    }

    uploader.onAfterAddingFile = function(fileItem) {
      //console.info('onAfterAddingFile', fileItem)
      editEvidenceVm.errorMsgFileType    = ''
      editEvidenceVm.disableButtonUpload = false
    }

    uploader.onSuccessItem = function(fileItem, response, status, headers) {
      //console.info('onSuccessItem', fileItem, response, status, headers)
      if(response.status){
        editEvidenceVm.fileName    = response.data
        editEvidenceVm.attachFile  = fileItem.file.name 
        editEvidenceVm.errorMsg    = false
      }
    }
    uploader.onErrorItem = function(fileItem, response, status, headers) {
      //console.info('onErrorItem', fileItem, response, status, headers)
      editEvidenceVm.errorMsg = true
    }

    uploader.onCompleteItem = function(fileItem, response, status, headers) {
      //console.info('onCompleteItem', fileItem, response, status, headers)      
      editEvidenceVm.loading = false
      editEvidenceVm.STATIC_IMAGE_URL = true    
    }

    uploader.onBeforeUploadItem = function(item) {
      let header = {
        userId : editEvidenceVm.userId,
      }
      item.formData.push(header);
      editEvidenceVm.loading  = true
      editEvidenceVm.errorMsg = false
    }

    function remove(){
      editEvidenceVm.attachFile = ''
      editEvidenceVm.STATIC_IMAGE_URL = false
      editEvidenceVm.loading = false
      editEvidenceVm.fileName = ''
      editEvidenceVm.errorMsg = false
      uploader.clearQueue()
      $('#inputFileUpload').val(null)
      
    }
    


  //forms methods
    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function validateForm (form) {
      return form.$invalid || editEvidenceVm.fileName == '' || editEvidenceVm.errorMsgFileType != ''
    }

  //utils functions
    function isImageType(fileTypeId){
      return fileTypeId == editEvidenceVm.globalFileTypes.image
    }

    function isDocumentType(fileTypeId){
      return fileTypeId == editEvidenceVm.globalFileTypes.document
    }

    function isVideoType(fileTypeId){
      return fileTypeId == editEvidenceVm.globalFileTypes.video
    }

    function isAudioType(fileTypeId){
      return fileTypeId == editEvidenceVm.globalFileTypes.audio
    }

    activate()

  }
}

EditEvidenceCtrl.$inject = ['$scope', '$mdDialog', 'PortfolioSrv', 'PortfolioModalSrv', 
                              'GlobalConfig', 'FileUploader', 'SERVICE_URL_CONSTANT']



// WEBPACK FOOTER //
// ./src/app/u-faculty/portfolio/myPortfolio/modals/editEvidenceCtrl.js